import React from "react";
import { Text } from "react-native-paper";
import { Image, View } from "react-native";
import AccordionItem from "../AccordionItem";

// do poprawienia bo jest teraz źle
const AccordionItemFull = ({ styles, j, subSection }) => {
  const img = subSection.image && (
    <Image
      resizeMode="contain"
      style={{
        width: 130,
        maxHeight: 130,

      }}
      source={subSection.image}
    />
  );
  const txt = (
    <View style={styles.textdescriptionDesign}>
      <Text style={styles.textSubtitle}>{subSection.title}</Text>
      <AccordionItem subSection={subSection} />
    </View>
  );

  return (
    <View style={{ paddingBottom: 10, paddingTop: 10 }}>
      <View style={styles.subSection} key={j}>
        {subSection.positionText === "right" ? (
          <>
            {img}
            {txt}
          </>
        ) : (
          <>
            {txt}
            {img}
          </>
        )}
      </View>
    </View>
  );
};

export default AccordionItemFull;
